/** A new WB Packing Slip. Nothing is written, and no number spent, until the first Post. */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { FormPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { WORK_ORDER_FORM } from "@/features/packaging/api";
import { WorkOrderPage } from "@/features/packaging/components/work-order-page";

export const Route = createFileRoute("/_app/packaging/wb-packing-slip/new")({
  beforeLoad: () => {
    if (!useAuth.getState().canCreateForm(WORK_ORDER_FORM))
      throw redirect({ to: "/packaging/wb-packing-slip" });
  },
  component: Page,
});

function Page() {
  const { selected, ready } = useFacilities();
  if (!ready) return <FormPageSkeleton />;
  return (
    <WorkOrderPage
      order={null}
      facilityId={selected?.id}
      plantName={selected ? `${selected.name} (${selected.plantCode})` : null}
    />
  );
}
